<panel *ngIf="!selected.invoice && (!loading || !invoices.empty)">

  <div class="uppercase" header>{{'Đơn hủy hàng mất' | lang}} ({{configs.invoiceResolvableDays}} {{'ngày' | lang}})</div>

  <div right class="flex">
    <text-filter class="flex-grow-1" [target]="invoices" [placeholder]="'Tìm kiếm đơn hàng'"></text-filter>
    <button class="bg-danger text-white hlf-margin-left" (click)="create()"><i class="fa fa-plus"></i></button>
  </div>

  <table responsive class="data hover">
    <tr>
      <th class="text-right" style="width: 0">{{'STT' | lang}}</th>
      <th class="text-left nowrap"><sortable [target]="invoices" [extractor]="extractor('Stamp')">{{'Ngày' | lang}}</sortable></th>
      <th class="text-center"><sortable [target]="invoices" [extractor]="extractor('ID')">{{'Mã đơn' | lang}}</sortable></th>
      <th class="text-center"><sortable [target]="invoices" [extractor]="extractor('Category')">{{'Loại đơn' | lang}}</sortable></th>
      <th class="text-center"><sortable [target]="invoices" [extractor]="extractor('State')" [selected]="true">{{'Trạng thái' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('SKUCount')">{{'Mặt hàng' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('Count')">{{'Số cây' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('LengthActualQuantity')">{{'Số mét' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('WeightActualQuantity')">{{'Số cân' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('Total')">{{'Tổng tiền' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of invoices.pageMatches; index as ix" class="pointer" (click)="open(i)">
      <td><small>{{ix + 1 + invoices.pageIndex * invoices.pageSize}}</small></td>
      <td>{{i.Stamp | date : 'dd-MM-yyyy'}}</td>
      <td class="spacy text-danger bold">{{i.Tag}}</td>
      <td class="uppercase small nowrap" [ngClass]="{'text-warning': i.Category == 3, 'text-danger': i.Category == 2}">{{category(i) | lang}}</td>
      <td class="uppercase small nowrap" [ngClass]="{'text-warning': i.State == 1, 'text-success': i.State == 2 && i.PartnerID == 1, 'text-danger': i.State == 2 && i.PartnerID == 2}">{{state(i) | lang}}</td>
      <td>{{i.SKUCount | number : '1.0-0' : 'en-US'}}</td>
      <td><b class="text-danger">{{i.LengthCount + i.WeightCount | number : '1.0-0' : 'en-US'}}</b></td>
      <td>{{i.LengthActualQuantity | number : '1.1-1' : 'en-US'}}<m></m></td>
      <td>{{i.WeightActualQuantity | number : '1.1-1' : 'en-US'}}<kg></kg></td>
      <td><b class="text-danger">{{i.Total | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">{{i.Icon}}</span></td>
    </tr>
    <tr class="footer" *ngIf="invoices.pages.length > 1">
      <td [colSpan]="10" class="text-center" style="display: table-cell !important"><pagination [target]="invoices"></pagination></td>
    </tr>
  </table>

</panel>

<div *ngIf="selected.invoice" class="editor">

  <div class="scrollable-x" #scrollableX>

    <div class="flex row">

      <panel [header]="false">

        <div class="flex col">

          <div class="flex space-between items-center header">
            <div class="bold uppercase">{{'Đơn báo ' + category(selected.invoice) | lang}} {{selected.invoice.Tag}} ({{state(selected.invoice) | lang}})</div>
            <small *ngIf="selected.invoice.ID > 0" class="button uppercase" (click)="close()">{{'Đóng đơn' | lang}}</small>
          </div>

          <div class="flex row">

            <div class="scrollable" #scrollableLeft>


              <table responsive class="data hover" *ngIf="selected.invoice">
                <tr>
                  <th class="text-top text-left">{{'Mã hàng' | lang}}</th>
                  <th class="text-top text-center">{{'Màu' | lang}}</th>
                  <th class="text-top text-center">{{'Số cây' | lang}}</th>
                  <th class="text-top text-left">{{'Độ dài từng cây' | lang}}</th>
                  <th class="text-top text-right">{{'Tổng dài' | lang}}</th>
                  <th class="text-top text-right">{{'Khấu trừ' | lang}}</th>
                  <th class="text-top text-right">{{'Tính tiền' | lang}}</th>
                  <th class="text-top text-right">{{'Giá hàng' | lang}}</th>
                  <th class="text-top text-right">{{'Thành tiền' | lang}}</th>
                </tr>
                <tr *ngFor="let i of selected.details">
                  <td><good class="bold spacy nowrap" [sku]="i.SKU"></good></td>
                  <td>{{i.Color}}</td>
                  <td class="bold">{{i.records.length | number : '1.0-0' : 'en-US'}}</td>
                  <td>
                    <div class="flex inputs">
                      <span *ngFor="let o of i.records">{{o.ActualQuantity | number : '1.1-1' : 'en-US'}}<i *ngIf="savable" class="fa fa-times text-danger pointer" (click)="remove(o)"></i></span>
                    </div>
                  </td>
                  <td>
                    <b>{{group.actualQuantity(i) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit>
                  </td>
                  <td class="bold">
                    <b>{{group.actualQuantity(i) - group.quoteQuantity(i) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit>
                  <td>
                    <b>{{group.quoteQuantity(i) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit>
                  </td>
                  <td>
                    <b>{{group.quoteUnitPrice(i) | number : '1.0-1' : 'en-US'}}</b><symbol-per-unit [symbol]="selected.invoice.Icon" [type]="i.Unit"></symbol-per-unit>
                  </td>
                  <td>
                    <b>{{group.subtotal(i) | number : '1.0-2' : 'en-US'}}</b><unit>{{selected.invoice.Icon}}</unit>
                  </td>
                </tr>

                <tr *ngIf="group.sum('Count', 1) > 0 && group.sum('Count', 2) > 0" class="bold">
                  <td>
                    <div class="uppercase nowrap">{{'TỔNG MÉT' | lang}}</div>
                    <div class="uppercase nowrap">{{'TỔNG CÂN' | lang}}</div>
                  </td>
                  <td></td>
                  <td>
                    <div>{{group.sum('Count', 1)}}</div>
                    <div>{{group.sum('Count', 2)}}</div>
                  </td>
                  <td></td>
                  <td>
                    <div>{{group.sum('ActualQuantity', 1) | number : '1.1-1' : 'en-US'}}<m></m></div>
                    <div>{{group.sum('ActualQuantity', 2) | number : '1.1-1' : 'en-US'}}<kg></kg></div>
                  </td>
                  <td>
                    <div>{{group.sum('Reduced', 1) | number : '1.1-1' : 'en-US'}}<m></m></div>
                    <div>{{group.sum('Reduced', 2) | number : '1.1-1' : 'en-US'}}<kg></kg></div>
                  </td>
                  <td>
                    <div>{{group.sum('QuoteQuantity', 1) | number : '1.1-1' : 'en-US'}}<m></m></div>
                    <div>{{group.sum('QuoteQuantity', 2) | number : '1.1-1' : 'en-US'}}<kg></kg></div>
                  </td>
                  <td></td>
                  <td>
                    <div>{{group.sum('Subtotal', 1) | number : '1.1-1' : 'en-US'}}<unit>{{selected.invoice.Icon}}</unit></div>
                    <div>{{group.sum('Subtotal', 2) | number : '1.1-1' : 'en-US'}}<unit>{{selected.invoice.Icon}}</unit></div>
                  </td>
                </tr>
                <tr class="footer bold text-primary" *ngIf="selected.details.length > 0">
                  <td class="uppercase nowrap">{{'TỔNG ĐƠN' | lang}}</td>
                  <td></td>
                  <td>{{group.sum('Count')}}</td>
                  <td></td>
                  <td class="nowrap">
                    {{group.sum('ActualQuantity') | number : '1.1-1' : 'en-US'}}
                    <m *ngIf="group.sum('Count', 1) > 0 && group.sum('Count', 2) < 1"></m>
                    <kg *ngIf="group.sum('Count', 2) > 0 && group.sum('Count', 1) < 1"></kg>
                    <unit *ngIf="group.sum('Count', 1) > 0 && group.sum('Count', 2) > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td class="nowrap">
                    {{group.sum('Reduced') | number : '1.1-1' : 'en-US'}}
                    <m *ngIf="group.sum('Count', 1) > 0 && group.sum('Count', 2) < 1"></m>
                    <kg *ngIf="group.sum('Count', 2) > 0 && group.sum('Count', 1) < 1"></kg>
                    <unit *ngIf="group.sum('Count', 1) > 0 && group.sum('Count', 2) > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td class="nowrap">
                    {{group.sum('QuoteQuantity') | number : '1.1-1' : 'en-US'}}
                    <m *ngIf="group.sum('Count', 1) > 0 && group.sum('Count', 2) < 1"></m>
                    <kg *ngIf="group.sum('Count', 2) > 0 && group.sum('Count', 1) < 1"></kg>
                    <unit *ngIf="group.sum('Count', 1) > 0 && group.sum('Count', 2) > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td></td>
                  <td class="nowrap">{{group.sum('Subtotal') | number : '1.0-1' : 'en-US'}}<unit>{{selected.invoice.Icon}}</unit></td>
                </tr>
              </table>

            </div>
            <scrollbar [target]="scrollableLeft"></scrollbar>

          </div>

          <div class="flex">
            <button *ngIf="creatable" class="bg-danger text-white" (click)="create()"><span>{{'Tạo đơn hủy hàng mất' | lang}}</span></button>
            <button *ngIf="savable" class="bg-danger text-white" (click)="save()"><span>{{'Tạo đơn hủy hàng mất' | lang}}</span></button>
            <button *ngIf="!creatable && !finishable" class="bg-warning text-white" (click)="close()"><span>{{'Hủy đơn báo mất hàng' | lang}}</span></button>
            <button *ngIf="finishable" class="bg-danger text-white" (click)="confirm()"><span>{{(selected.invoice.PartnerID == 1 ? 'Xưởng chịu trách nhiệm' : 'Xác nhận mất hàng') | lang}}</span></button>
            <button *ngIf="finishable" class="bg-warning text-white" (click)="cancel()"><span>{{(selected.invoice.PartnerID == 1 && selected.invoice.ID > 0 ? 'Xử lý tại công ty' : 'Hủy đơn báo mất hàng') | lang}}</span></button>
          </div>
        </div>
      </panel>

      <panel [header]="false" *ngIf="selected.invoice.ID == 0 && !goods.empty">

        <div class="flex col">

          <text-filter [target]="goods" [placeholder]="'Tìm kiếm'"></text-filter>
          <div class="flex row">
            <div class="scrollable" #scrollableRight>

              <table class="data hover">
                <tr>
                  <th class="text-left">Mã hàng</th>
                  <th class="text-center">Màu</th>
                  <th class="text-right">Dài / nặng</th>
                  <th class="text-right">Nguồn</th>
                </tr>
                <tr *ngFor="let i of goods.pageMatches" (click)="add(i)">
                  <td class="text-left"><good class="bold spacy nowrap" [sku]="i.SKU"></good></td>
                  <td class="text-center bold text-info">{{i.Color}}</td>
                  <td class="text-right">{{i.ActualQuantity}}<product-unit [type]="i.Unit"></product-unit></td>
                  <td class="text-right nowrap">
                    <div class="small spacy">{{i.ImportInvoiceTag}}</div>
                    <small>{{partner(i.ImportInvoiceTag)}}</small>
                  </td>
                </tr>
                <tr class="footer" *ngIf="goods.pages.length > 1">
                  <td [colSpan]="4" class="text-center"><pagination [target]="goods"></pagination></td>
                </tr>
              </table>
            </div>
            <scrollbar [target]="scrollableRight"></scrollbar>
          </div>
        </div>
      </panel>

    </div>

  </div>

  <scrollbar [target]="scrollableX" class="bottom"></scrollbar>

</div>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
